import React from 'react';
import { convertStyleData } from '@utils/tools';

import { getAppId } from '@utils/global';
import { ajax } from '@utils/http';

import './VideoCustomComponent.less';

export default class VideoCustomComponent extends React.Component {

  state = {
    hidden: false,  // 是否显示
    videoUrl: null, // 视频地址
    videoPic: null, // 视频图片
    playing: false, // 播放状态
  }

  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
  }
  componentDidMount() {
    const customFeature = this.props.data.customFeature;
    switch(customFeature.usage) {
      // 小程序：源文件
      case 'xcx':
        this.setState({
          videoUrl: customFeature.videoSourceUrl
        });
        break;
      // 小程序：视频库
      case 'videoLibrary':
        this.getVideoLibrary();
        break;
      // 小程序：视频项目
      case 'videoProject':
        this.getVideoProject();
        break;
      // 小程序：腾讯视频
      case 'tencentVideo':
        this.getTencentVideo();
        break;
      // 网页应用、默认
      case 'webapp':
      default:
        this.setState({
          videoUrl: this.props.data.content
        });
        break;
    }
  }
  /**
   * 获取视频库地址
   */
  getVideoLibrary = () => {
    const customFeature = this.props.data.customFeature;
    const param = {
      app_id: getAppId(),
      id: customFeature['video-id']
    }
    ajax({
      url: '/index.php?r=AppVideo/GetVideoLibUrl',
      data: param,
      success: (res) => {
        if (res.status !== 0) {
          return;
        }
        if (res.data.is_deleted == 1) {
          this.setState({
            hidden: true
          })
        } else {
          this.setState({
            videoUrl: res.data,
            videoPic: customFeature['video-pic'],
          })
        }
      }
    });
  }
  /**
   * 获取视频项目地址
   */
  getVideoProject = () => {
    const customFeature = this.props.data.customFeature;
    const param = {
      app_id: getAppId(),
      id: customFeature['videoProjectId']
    }
    ajax({
      url: '/index.php?r=AppVideo/GetProjectInfo',
      data: param,
      success: (res) => {
        if (res.status !== 0) {
          return;
        }
        if (res.data.is_deleted == 1) {
          this.setState({
            hidden: true
          })
        } else {
          this.setState({
            videoUrl: res.data.video_url,
            videoPic: customFeature['preview_img'],
          })
        }
      }
    });
  }
  /**
   * 获取腾讯视频地址
   */
  getTencentVideo = () => {
    const customFeature = this.props.data.customFeature;
    const param = {
      app_id: getAppId(),
      argv: customFeature.vid
    }
    ajax({
      url: '/index.php?r=AppNews/GetVideoUrl',
      data: param,
      success: (res) => {
        if (res.status !== 0) {
          return;
        }
        this.setState({
          videoUrl: res.data
        })
      }
    });
  }
  /**
   * 视频播放
   */
  videoPlay = () => {
    this.videoRef.current.play();
    this.setState({
      playing: true
    })
  }
  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    const detailData = this.props.detailData;    // 详情页数据
    const dynamicData = this.props.dynamicData;  // 动态数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    /**
     * 组件内容处理（TODO：动态数据未处理）
     */   
    let content = data.content;
    const segment = data.customFeature.segment; // 已绑定字段
    // 是否有绑定字段
    if (segment) {
      if (detailData && detailData[segment]) {
        content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
      } else if (dynamicData && dynamicData[segment]) {
        content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
      }
    }
    /**
     * 根据customFeature.usage字段生成对应内容
     */  
    const $content = (usage) => {
      const $video = <video ref={this.videoRef} src={this.state.videoUrl} controls preload="meta"></video>;
      const $cover = (!this.state.playing && 
        <div className="cover-wrap" onClick={this.videoPlay}>
          <img className="cover" src={this.state.videoPic}/>
          <span className="icon-play"></span>
        </div>
      );
      switch(usage) {
        // 小程序：源文件
        case 'xcx':
        // 小程序：腾讯视频
        case 'tencentVideo':
          return $video;
        // 小程序：视频库
        case 'videoLibrary':
        // 小程序：视频项目
        case 'videoProject':
          return <React.Fragment>{$video}{$cover}</React.Fragment>;
        // 网页应用、默认
        case 'webapp':
        default:
          return this.state.videoUrl; // 视频通用路径
      }
    }
    /**
     * 返回组件
     */ 
    return (
      !this.state.hidden && <div className="custom-component video" style={styleObj}>
        {$content(customFeature.usage)}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/video-custom-component/VideoCustomComponent.jsx